import { useEffect, useState } from "react";

/** Next Sunday 12:00 PM local (MYT) announcement target */
export function getNextAnnouncementDate() {
  const now = new Date();
  const target = new Date(now);

  if (now.getDay() === 0 && now.getHours() < 12) {
    target.setHours(12, 0, 0, 0);
    return target;
  }

  const daysUntilSunday = now.getDay() === 0 ? 7 : 7 - now.getDay();
  target.setDate(target.getDate() + daysUntilSunday);
  target.setHours(12, 0, 0, 0);
  return target;
}

export function getCountdownParts(target) {
  const diff = Math.max(0, target.getTime() - Date.now());
  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds, done: diff <= 0 };
}

export default function useSundayCountdown() {
  const [target] = useState(getNextAnnouncementDate);
  const [parts, setParts] = useState(() => getCountdownParts(target));

  useEffect(() => {
    const tick = () => setParts(getCountdownParts(target));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [target]);

  return parts;
}
